import { Box, Button, Radio, Typography } from '@mui/material'
import { withStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import * as api from '../services/api'
import Loader from '../../components/Loader';
import ModalConfirm from '../../components/modal/ModalConfirm';

const GreenRadio = withStyles({
    root: {
        color: "#696984",
        "&$checked": {
            color: "#478F96",
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />)

function DepressionAssessment() {

    const location = useLocation()

    const [inform, setInform] = useState(null)

    const [evaluate_9q1, setEvaluate_9q1] = useState(null);
    const [evaluate_9q2, setEvaluate_9q2] = useState(null);
    const [evaluate_9q3, setEvaluate_9q3] = useState(null);
    const [evaluate_9q4, setEvaluate_9q4] = useState(null);
    const [evaluate_9q5, setEvaluate_9q5] = useState(null);
    const [evaluate_9q6, setEvaluate_9q6] = useState(null);
    const [evaluate_9q7, setEvaluate_9q7] = useState(null);
    const [evaluate_9q8, setEvaluate_9q8] = useState(null);
    const [evaluate_9q9, setEvaluate_9q9] = useState(null);

    const valueDepress = [0, 1, 2, 3]

    const [information, setInformation] = useState({})
    const [openModalConfirm, setOpenModalConfirm] = useState(false)

    useEffect(() => {
        console.log(location.state)
        setInform(location.state)
    }, [])

    const saveDepress = () => {
        let data = {
            "title_name": inform['title_name'],
            "department_code": inform['department_code'],
            "firstname": inform['firstname'],
            "lastname": inform['lastname'],
            "gender": inform['gender'],
            "age": inform['age'],
            "pid": inform['pid'],
            "phone": inform['phone'],
            "evaluate_rq": [
                {
                    "question": "1) ฉันเอาชนะอุปสรรคปัญหาต่าง ๆ ในชีวิตได้",
                    "score": inform['evaluate_rq1']
                },
                {
                    "question": "2) ฉันมีกำลังใจและได้รับการสนับสนุนจากคนรอบข้าง",
                    "score": inform['evaluate_rq2']
                },
                {
                    "question": "3) ฉันจัดการกับปัญหาและความเครียดของตนเองได้",
                    "score": inform['evaluate_rq3']
                }
            ],
            "evaluate_burnout": [
                {
                    "question": "1) ท่านรู้สึกอ่อนล้าทางจิตใจ",
                    "score": inform['evaluate_burnout1']
                },
                {
                    "question": "2) ท่านรู้สึกขาดแรงใจ/ ความกระตือรือร้น",
                    "score": inform['evaluate_burnout2']
                },
                {
                    "question": "3) ท่านรู้สึกไม่ดีกับคนรอบข้าง",
                    "score": inform['evaluate_burnout3']
                },
                {
                    "question": "4) ท่านรู้สึกไม่อยากสนใจคนรอบข้าง",
                    "score": inform['evaluate_burnout4']
                },
                {
                    "question": "5) ท่านรู้สึกไม่มีความสุขในการทำงาน",
                    "score": inform['evaluate_burnout5']
                },
                {
                    "question": "6) ท่านรู้สึกไม่ประสบความสำเร็จเท่าที่ควร",
                    "score": inform['evaluate_burnout6']
                }
            ],
            "evaluate_st5": [
                {
                    "question": "1) มีปัญหาการนอน นอนไม่หลับ หรือนอนมาก",
                    "score": inform['evaluate_st1']
                },
                {
                    "question": "2) มีสมาธิน้อยลง",
                    "score": inform['evaluate_st2']
                },
                {
                    "question": "3) หงุดหงิด กระวนกระวาย ว้าวุ่นใจ",
                    "score": inform['evaluate_st3']
                },
                {
                    "question": "4) รู้สึกเบื่อหน่าย เซ็ง",
                    "score": inform['evaluate_st4']
                },
                {
                    "question": "5) ไม่อยากพบปะผู้คน",
                    "score": inform['evaluate_st5']
                }
            ],
            "evaluate_9q": [
                {
                    "question": "1) เบื่อ ไม่สนใจอยากทำอะไร",
                    "score": evaluate_9q1
                },
                {
                    "question": "2) ไม่สบายใจ ซึมเศร้า ท้อแท้",
                    "score": evaluate_9q2
                },
                {
                    "question": "3) หลับยาก หรือหลับ ๆ ตื่น ๆ หรือหลับมากไป",
                    "score": evaluate_9q3
                },
                {
                    "question": "4) เหนื่อยง่าย หรือไม่ค่อยมีแรง",
                    "score": evaluate_9q4
                },
                {
                    "question": "5) เบื่ออาหาร หรือกินมากเกินไป",
                    "score": evaluate_9q5
                },
                {
                    "question": "6) รู้สึกไม่ดีกับตัวเอง คิดว่าตัวเองล้มเหลว หรือครอบครัวผิดหวัง",
                    "score": evaluate_9q6
                },
                {
                    "question": "7) สมาธิไม่ดี เวลาทำอะไร เช่น ดูโทรทัศน์ ฟังวิทยุ หรือทำงานที่ต้องใช้ความตั้งใจ",
                    "score": evaluate_9q7
                },
                {
                    "question": "8) พูดช้า ทำอะไรช้าลง จนคนอื่นสังเกตเห็นได้ หรือ กระสับกระส่าย ไม่สามารถอยู่นิ่งได้เหมือนที่เคยเป็น",
                    "score": evaluate_9q8
                },
                {
                    "question": "9) คิดทำร้ายตนเอง หรือคิดว่าถ้าตายไปคงจะดี",
                    "score": evaluate_9q9
                }
            ]
        }
        // console.log(information)
        setInformation(data)
        setOpenModalConfirm(true)
    }

    return (
        <>
            {openModalConfirm &&
                <ModalConfirm
                    data={information}
                    onFinished={() => {
                        // console.log('onFinished')
                    }}
                    onClose={() => { setOpenModalConfirm(false) }}
                />
            }
            <Box
                sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}
            >
                แบบประเมินสุขภาพใจ
            </Box>
            <Box
                sx={{
                    display: "grid",
                    gridGap: "20px",
                }}
            >
                <Box sx={{
                    fontWeight: 600,
                    "@media (max-width: 800px)": {
                        fontSize: "14px",
                    },
                }}>
                    เพิ่มเติม : แบบคัดกรองโรคซึมเศร้าด้วย 9 คำถาม (9Q)
                </Box>
                <Box sx={{ margin: "0 20px" }}>
                    <Typography sx={{
                        "@media (max-width: 800px)": {
                            fontSize: "12px",
                        },
                    }}>
                        ในช่วง 2 สัปดาห์ที่ผ่านมารวมทั้งวันนี้ท่านมีอาการเหล่านี้ บ่อยแค่ไหน
                    </Typography>
                </Box>
                <Box
                    sx={{
                        border: "1px solid #AEB4DD",
                        borderRadius: "5px",
                        padding: "20px",
                    }}
                >
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        "@media (max-width: 800px)": {
                            gridTemplateColumns: '1fr'
                        },
                    }}>
                        <Box></Box>
                        <Box sx={{
                            fontWeight: 600,
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr 1fr',
                            textAlign: 'center',
                            color: '#478F96',
                            "@media (max-width: 800px)": {
                                padding: '10px 0',
                                fontSize: "14px",
                            },
                        }}>
                            <Box>ไม่มีเลย</Box>
                            <Box>เป็นบางวัน 1-7 วัน</Box>
                            <Box>เป็นบ่อย มากกว่า 7 วัน</Box>
                            <Box>เป็นทุกวัน</Box>
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        alignItems: 'center',
                        "@media (max-width: 800px)": {
                            gridTemplateColumns: '1fr',
                            textAlign: 'center',
                            fontSize: '12px'
                        },
                    }}>
                        <Box>1) เบื่อ ไม่สนใจอยากทำอะไร</Box>
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr 1fr',
                            textAlign: 'center'
                        }}>
                            {valueDepress.map((item, index) => (
                                <GreenRadio
                                    key={index}
                                    checked={evaluate_9q1 === item}
                                    onChange={() => { setEvaluate_9q1(item); }}
                                    value={evaluate_9q1}
                                    name="radio-button-demo"
                                />
                            ))}
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        alignItems: 'center',
                        "@media (max-width: 800px)": {
                            gridTemplateColumns: '1fr',
                            textAlign: 'center',
                            fontSize: '12px'
                        },
                    }}>
                        <Box>2) ไม่สบายใจ ซึมเศร้า ท้อแท้</Box>
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr 1fr',
                            textAlign: 'center'
                        }}>
                            {valueDepress.map((item, index) => (
                                <GreenRadio
                                    key={index}
                                    checked={evaluate_9q2 === item}
                                    onChange={() => { setEvaluate_9q2(item); }}
                                    value={evaluate_9q2}
                                    name="radio-button-demo"
                                />
                            ))}
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        alignItems: 'center',
                        "@media (max-width: 800px)": {
                            gridTemplateColumns: '1fr',
                            textAlign: 'center',
                            fontSize: '12px'
                        },
                    }}>
                        <Box>3) หลับยาก หรือหลับ ๆ ตื่น ๆ หรือหลับมากไป</Box>
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr 1fr',
                            textAlign: 'center'
                        }}>
                            {valueDepress.map((item, index) => (
                                <GreenRadio
                                    key={index}
                                    checked={evaluate_9q3 === item}
                                    onChange={() => { setEvaluate_9q3(item); }}
                                    value={evaluate_9q3}
                                    name="radio-button-demo"
                                />
                            ))}
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        alignItems: 'center',
                        "@media (max-width: 800px)": {
                            gridTemplateColumns: '1fr',
                            textAlign: 'center',
                            fontSize: '12px'
                        },
                    }}>
                        <Box>4) เหนื่อยง่าย หรือไม่ค่อยมีแรง</Box>
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr 1fr',
                            textAlign: 'center'
                        }}>
                            {valueDepress.map((item, index) => (
                                <GreenRadio
                                    key={index}
                                    checked={evaluate_9q4 === item}
                                    onChange={() => { setEvaluate_9q4(item); }}
                                    value={evaluate_9q4}
                                    name="radio-button-demo"
                                />
                            ))}
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        alignItems: 'center',
                        "@media (max-width: 800px)": {
                            gridTemplateColumns: '1fr',
                            textAlign: 'center',
                            fontSize: '12px'
                        },
                    }}>
                        <Box>5) เบื่ออาหาร หรือกินมากเกินไป</Box>
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr 1fr',
                            textAlign: 'center'
                        }}>
                            {valueDepress.map((item, index) => (
                                <GreenRadio
                                    key={index}
                                    checked={evaluate_9q5 === item}
                                    onChange={() => { setEvaluate_9q5(item); }}
                                    value={evaluate_9q5}
                                    name="radio-button-demo"
                                />
                            ))}
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        alignItems: 'center',
                        "@media (max-width: 800px)": {
                            gridTemplateColumns: '1fr',
                            textAlign: 'center',
                            fontSize: '12px'
                        },
                    }}>
                        <Box>6) รู้สึกไม่ดีกับตัวเอง คิดว่าตัวเองล้มเหลว หรือครอบครัวผิดหวัง</Box>
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr 1fr',
                            textAlign: 'center'
                        }}>
                            {valueDepress.map((item, index) => (
                                <GreenRadio
                                    key={index}
                                    checked={evaluate_9q6 === item}
                                    onChange={() => { setEvaluate_9q6(item); }}
                                    value={evaluate_9q6}
                                    name="radio-button-demo"
                                />
                            ))}
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        alignItems: 'center',
                        "@media (max-width: 800px)": {
                            gridTemplateColumns: '1fr',
                            textAlign: 'center',
                            fontSize: '12px'
                        },
                    }}>
                        <Box>7) สมาธิไม่ดี เวลาทำอะไร เช่น ดูโทรทัศน์ ฟังวิทยุ หรือทำงานที่ต้องใช้ความตั้งใจ</Box>
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr 1fr',
                            textAlign: 'center'
                        }}>
                            {valueDepress.map((item, index) => (
                                <GreenRadio
                                    key={index}
                                    checked={evaluate_9q7 === item}
                                    onChange={() => { setEvaluate_9q7(item); }}
                                    value={evaluate_9q7}
                                    name="radio-button-demo"
                                />
                            ))}
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        alignItems: 'center',
                        "@media (max-width: 800px)": {
                            gridTemplateColumns: '1fr',
                            textAlign: 'center',
                            fontSize: '12px'
                        },
                    }}>
                        <Box>8) พูดช้า ทำอะไรช้าลง จนคนอื่นสังเกตเห็นได้ หรือ กระสับกระส่าย ไม่สามารถอยู่นิ่งได้เหมือนที่เคยเป็น</Box>
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr 1fr',
                            textAlign: 'center'
                        }}>
                            {valueDepress.map((item, index) => (
                                <GreenRadio
                                    key={index}
                                    checked={evaluate_9q8 === item}
                                    onChange={() => { setEvaluate_9q8(item); }}
                                    value={evaluate_9q8}
                                    name="radio-button-demo"
                                />
                            ))}
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        alignItems: 'center',
                        "@media (max-width: 800px)": {
                            gridTemplateColumns: '1fr',
                            textAlign: 'center',
                            fontSize: '12px'
                        },
                    }}>
                        <Box>9) คิดทำร้ายตนเอง หรือคิดว่าถ้าตายไปคงจะดี</Box>
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr 1fr',
                            textAlign: 'center'
                        }}>
                            {valueDepress.map((item, index) => (
                                <GreenRadio
                                    key={index}
                                    checked={evaluate_9q9 === item}
                                    onChange={() => { setEvaluate_9q9(item); }}
                                    value={evaluate_9q9}
                                    name="radio-button-demo"
                                />
                            ))}
                        </Box>
                    </Box>

                </Box>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center"
                    }}
                >
                    <Button
                        variant="contained"
                        sx={{
                            width: "150px",
                            "@media (max-width: 800px)": {
                                width: "100px",
                            },
                        }}
                        onClick={() => {
                            if (evaluate_9q1 === null) {
                                return alert('กรุณาทำแบบคัดกรองโรคซึมเศร้าข้อที่ 1')
                            }
                            if (evaluate_9q2 === null) {
                                return alert('กรุณาทำแบบคัดกรองโรคซึมเศร้าข้อที่ 2')
                            }
                            if (evaluate_9q3 === null) {
                                return alert('กรุณาทำแบบคัดกรองโรคซึมเศร้าข้อที่ 3')
                            }
                            if (evaluate_9q4 === null) {
                                return alert('กรุณาทำแบบคัดกรองโรคซึมเศร้าข้อที่ 4')
                            }
                            if (evaluate_9q5 === null) {
                                return alert('กรุณาทำแบบคัดกรองโรคซึมเศร้าข้อที่ 5')
                            }
                            if (evaluate_9q6 === null) {
                                return alert('กรุณาทำแบบคัดกรองโรคซึมเศร้าข้อที่ 6')
                            }
                            if (evaluate_9q7 === null) {
                                return alert('กรุณาทำแบบคัดกรองโรคซึมเศร้าข้อที่ 7')
                            }
                            if (evaluate_9q8 === null) {
                                return alert('กรุณาทำแบบคัดกรองโรคซึมเศร้าข้อที่ 8')
                            }
                            if (evaluate_9q9 === null) {
                                return alert('กรุณาทำแบบคัดกรองโรคซึมเศร้าข้อที่ 9')
                            }
                            saveDepress()
                        }}
                    >
                        บันทึก
                    </Button>
                </Box>
            </Box>
        </>
    )
}

export default DepressionAssessment
